module.exports = __webpack_public_path__ + "img/23.963b10e.png";